import React, { useState } from 'react'
import { strCol } from '@integec/grid-tools/lib/cols'

import {
  wind2TurbineType,
  wind2TurbineTypeDelete,
  wind2TurbineTypeSave,
} from 'api/pgads.js'

import CommonScreen from 'admin/component/CommonScreen'
import { modifiedDateCol, modifierCol } from 'core/HeaderColTypeProps'
import { Label } from 'core/screen-util'
import { Button, Input } from 'antd'

const Wind2TurbineType = _ => {
  const [insertEvent, setInsertEvent] = useState(false)
  const insertComp = ({ insertData = {}, setInsertData, onAdd, onCancel }) => {
    return (
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '150px 600px',
          gap: 10,
          width: '100%',
        }}
      >
        <div>
          <Label style={{ display: 'inline', float: 'right' }}>
            Turbine Type :
          </Label>
          <span style={{ color: 'red', marginRight: '2px', float: 'right' }}>
            *
          </span>
        </div>
        {/* <Label>Turbine Type :</Label> */}
        <Input
          value={insertData.turbineType}
          data-cy="turbinetype"
          onChange={e =>
            setInsertData({
              ...insertData,
              turbineType: e.target.value,
            })
          }
        />
        <div>
          <Label style={{ display: 'inline', float: 'right' }}>
            Turbine Type Code :
          </Label>
          <span style={{ color: 'red', marginRight: '2px', float: 'right' }}>
            *
          </span>
        </div>
        {/* <Label>Turbine Type Code :</Label> */}
        <Input
          value={insertData.turbineTypeCode}
          data-cy="turbinetypecode"
          onChange={e =>
            setInsertData({
              ...insertData,
              turbineTypeCode: e.target.value,
            })
          }
        />

        <div>
          <Label style={{ display: 'inline', float: 'right' }}>
            Description :
          </Label>
        </div>
        {/* <Label>Description :</Label> */}
        <Input
          value={insertData.description}
          data-cy="description"
          onChange={e =>
            setInsertData({
              ...insertData,
              description: e.target.value,
            })
          }
        />

        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr 1fr',
            gap: 10,
            gridColumnStart: 2,
            // gridColumnEnd: 'span 2',
          }}
        >
          <Button type="primary" onClick={() => onAdd(true)}>
            Add
          </Button>
          <Button type="primary" onClick={() => onAdd(false)}>
            Add & Hide
          </Button>
          <Button type="danger" onClick={onCancel}>
            Cancel
          </Button>
        </div>
      </div>
    )
  }
  return (
    <CommonScreen
      title="Turbine Type"
      header={Wind2TurbineTypeHeaders}
      sortOptions={Wind2TurbineTypeHeaders}
      saveTask={wind2TurbineTypeSave}
      retrieveTask={wind2TurbineType}
      deleteTask={wind2TurbineTypeDelete}
      autoRetrieve
      insertComp={insertEvent && insertComp}
      insertCompHeight={90}
      onInsertEvent={b => setInsertEvent(b)}
      headerRowHeight={30}
      widthOffset={20}
      // heightOffset={100}
    />
  )
}

export default Wind2TurbineType

const Wind2TurbineTypeHeaders = [
  strCol({
    ident: 'turbineType',
    display: 'Turbine Type',
    isKey: true,
    width: 600,
    sortOrder: 'asc',
    ellipsis: true,
    alignment: 'left',
  }),
  strCol({
    ident: 'turbineTypeCode',
    display: 'Turbine Type Code',
    isKey: true,
    width: 150,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'description',
    display: 'Description',
    isFiltered: true,
    width: 700,
    sortOrder: 'asc',
    ellipsis: true,
    alignment: 'left',
  }),

  modifierCol,
  modifiedDateCol,
]
